<template>
    <div data-test="trust-browser">
        <h1 class="mb-1 text-center">
            Trust this browser?
        </h1>

        <div class="mb-4 text-center">
            <span class="text-muted">
                {{ email }}
            </span>
        </div>

        <p>
            You're signed in. If you trust this browser, you can skip the second step on it for the next 30 days.
        </p>

        <div class="border-top pt-3">
            <ul class="pl-3">
                <li class="mb-1">You'll still enter your password every time.</li>
                <li class="mb-1">Only trust a computer or phone that you alone use, not a shared or public one.</li>
                <li class="mb-1">You can stop trusting it at any time in Settings / Account &amp; Security.</li>
            </ul>
        </div>

        <!-- Button footer -->
        <div class="border-top pt-1">
            <div class="py-2">
                <button type="button" class="btn btn-primary mr-2 mb-1" :disabled="busy" @click="trust">Trust this browser</button>
                <button type="button" class="btn btn-link mb-1" :disabled="busy" @click="$emit('done')">Not now</button>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'

export default {
    props: {
        email: {type: String, default: ''},
    },
    emits: ['done'],
    data() {
        return {busy: false}
    },
    methods: {
        trust() {
            if (this.busy) {
                return
            }
            this.busy = true
            // Failing to set the cookie only means the next login asks again
            api.post('/account/mfa/trust-browser', {}).catch(() => {}).then(() => {
                this.$emit('done')
            })
        },
    },
}
</script>
